import React from 'react'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
import Loader from 'react-loader-spinner'
const LoaderComponent = () => {
  return (
    <Loader
      type="TailSpin"
      color="white"
      height={20}
      width={20}
      timeout={3000} //3 secs
    />
  )
}

export default LoaderComponent
